export function ellipse(text: string, limit: number, ellipseChars: string | undefined = '...'): string {
    if (text.length > limit) {
        return text.substring(0, limit - ellipseChars.length) + ellipseChars;
    } else {
        return text;
    }
}

export function isStringInArray(stringToFind: string, arrayOfStrings: string[], caseSensitive = false): boolean {
    // We use for-of loops here instead of a .forEach or .filter so we can short circuit early.
    for (const stringInArray of arrayOfStrings) {
        if (caseSensitive) {
            if (stringToFind.trim() === stringInArray.trim()) {
                return true;
            }
        } else {
            if (stringToFind.toLowerCase().trim() === stringInArray.toLowerCase().trim()) {
                return true;
            }
        }
    }

    return false;
}

export function capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function capitalizeEachWord(words: string): string {
    return words
        .split(' ')
        .map(w => capitalizeFirstLetter(w.toLowerCase()))
        .join(' ');
}



// WEBPACK FOOTER //
// ./src/utils/string.ts